import {sendServerRequest} from './baseService';

export const cityService = {
    getCity,
};

async function getCity(postCode) {
    return sendServerRequest('GET', `/api/city/${postCode}`);
}
